import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import scriptReducer from './scriptSlice';
import practiceReducer from './practiceSlice';
import settingsReducer from './settingsSlice';

export const store = configureStore({
    reducer: {
        script: scriptReducer,
        practice: practiceReducer,
        settings: settingsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
